// @flow
import * as React from 'react'

export const Play = ({
  color,
  arrowColor,
}: {
  color?: string,
  arrowColor?: string,
}) => (
  <svg
    width="165"
    height="164"
    viewBox="0 0 165 164"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="oval"
      d="M82.5 163.299C128.063 163.299 165 126.744 165 81.6497C165 36.5558 128.063 0 82.5 0C36.9365 0 0 36.5558 0 81.6497C0 126.744 36.9365 163.299 82.5 163.299Z"
      fill={color || '#FFDE91'}
    />
    <path
      id="triangle"
      d="M67.106 110.983L113.564 82.5919L67.106 54.2009V110.983Z"
      fill={arrowColor || '#2C1338'}
    />
  </svg>
)
